/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Button,
  Typography,
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { IconLabelButton } from '../territorycard/Buttons';

export interface Applicant {
  id: number;
  date: Date;
  userId: string;
  userName: string;
  created: Date;
}

interface ApplicantRecordsProps {
  date: Dayjs | null;
  applicants: Applicant[];
  onRegister?: () => void;
  onDelete?: (id: number, name: string) => () => void;
  onReload?: () => void;
}

export function ApplicantRecords({
  date,
  applicants,
  onRegister,
  onDelete,
  onReload,
}: ApplicantRecordsProps) {
  const dateExpression = date?.locale('ko').format('YYYY-MM-DD (dd)');
  // 토요일은 오후, 그 외(금요일)는 저녁 전시대 봉사
  const dateExpressionWithPostfix = dateExpression?.includes('토')
    ? `${dateExpression} 오후`
    : `${dateExpression} 저녁`;

  return (
    <Grid container spacing={0.5}>
      <Grid
        item
        // xs
        container
        direction="row"
        // justifyContent="space-between"
        alignItems="stretch"
        spacing={2}
      >
        <Grid item xs={11}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={8}>
              <Typography component="h2" variant="h6" gutterBottom>
                신청자 정보
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <IconLabelButton
                // disabled
                visible
                // label
                iconName="reload"
                onClick={onReload}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography>{dateExpressionWithPostfix} </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" fullWidth onClick={onRegister}>
            신청하기
          </Button>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>지원자</TableCell>
              <TableCell>신청일자</TableCell>
              <TableCell>취소하기</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {applicants.map((applicant: Applicant) => (
              <TableRow key={applicant.id}>
                <TableCell>{applicant.userName}</TableCell>
                <TableCell>
                  {dayjs(applicant.created).local().format('YYYY-MM-DD')}
                </TableCell>
                <TableCell>
                  <IconLabelButton
                    // disabled
                    visible
                    // label
                    iconName="delete"
                    onClick={onDelete?.(applicant.id, applicant.userId)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
}
